import React, { useEffect, useState } from 'react';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { fetchApi } from '../../services/api';

interface PartTagsResponse {
  Tags: string[];
}

type Props = {
  value: string[];
  disabled?: boolean;
  className?: string;
  onChange: (tags: string[]) => void;
};

export const parsePartTags = (tags?: string | null): string[] =>
  tags ? tags.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0) : [];

const PartTagsInput: React.FC<Props> = ({ value, disabled, className, onChange }) => {
  const [tags, setTags] = useState<string[]>([]);

  useEffect(() => {
    const loadTags = async () => {
      try {
        const response: PartTagsResponse = await fetchApi('/api/ShopInventory/PartTags');
        setTags(response.Tags);
      } catch (error) {
        console.error('Error loading part tags:', error);
      }
    };

    loadTags();
  }, []);

  return (
    <MultiSelect
      allowCustom
      disabled={disabled}
      className={className}
      data={tags}
      value={value}
      placeholder="Add tags..."
      onChange={(e) => onChange(e.value as string[])}
    />
  );
};

export default PartTagsInput;
